/**
 * @graphql cc
 */
import gql from 'graphql-tag';
import type { FC } from 'react';
import React, { Fragment } from 'react';
import { useQuery } from '@apollo/react-hooks';

import { ErrorDisplay } from '@confluence/error-boundary';

import type { RenderForUserPermissionTypeUserPermissionTypeQuery as RenderForUserPermissionTypeUserPermissionTypeQuery$data } from './__types__/RenderForUserPermissionTypeUserPermissionTypeQuery';

export enum SitePermissionType {
	ANONYMOUS = 'ANONYMOUS',
	APP = 'APP',
	EXTERNAL = 'EXTERNAL',
	INTERNAL = 'INTERNAL',
	JSD = 'JSD',
}

type RenderForUserPermissionTypeProps = {
	children: React.ReactNode;
	excludedPermissionTypes?: SitePermissionType[];
};

export const RenderForUserPermissionType: FC<RenderForUserPermissionTypeProps> = ({
	children,
	// "allowedPermissionTypes" prop can easily be added as needed
	excludedPermissionTypes = [],
}) => {
	const { data, error } = useQuery<RenderForUserPermissionTypeUserPermissionTypeQuery$data>(gql`
		query RenderForUserPermissionTypeUserPermissionTypeQuery {
			user: confluence_atlassianUser(current: true) {
				id
				confluence {
					permissionType
				}
			}
			tenant {
				editions {
					edition
				}
			}
		}
	`);
	const userPermissionType = data?.user?.confluence?.permissionType;

	return error ? (
		<ErrorDisplay error={error} />
	) : !userPermissionType || !excludedPermissionTypes.includes(userPermissionType) ? (
		<Fragment>{children}</Fragment>
	) : null;
};
